import store from '../store/store';
import { action } from 'satcheljs/lib/legacy';
export default action('clearNewCategoryState')(function clearNewCategoryState() {
    store.newCategory = {};
});
//# sourceMappingURL=clearNewCategoryState.js.map